import styled from 'styled-components';
import mainColors from '../../../../Style-guide/main-colors';

const AdminAuthWrapper = styled.div`
  background: ${mainColors.main_color_gradient};
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100vh;
  padding: 0 20px;

  .content-container {
    border-radius: 50px;
    padding: 60px;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .admin-login-title {
    text-align: center;
  }

  .admin-verification-input {
    .password-field {
      border-radius: 20px;
    }

    .input-field-with-icon-container {
      :focus,
      :hover {
        background-color: ${mainColors.dark_background};
      }

      .show-hide-icon {
        background-color: transparent;

        :hover {
          background-color: transparent;
        }
      }
    }
  }

  .submit-btn {
    padding: 4px 16px;
    background-color: ${mainColors.dark_background};
  }
`;

export default AdminAuthWrapper;
